import paymentsFlowExperiments from 'bundles/epic/clients/payments';

export const generateImpressionForHideAuditFromCoursesInS12nTest = () => {
  paymentsFlowExperiments.get('hideAuditFromCourseInS12n');
};

export const previewHideAuditFromCourseInS12n = () => {
  return paymentsFlowExperiments.preview('hideAuditFromCourseInS12n');
};
